var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-product-gallery"},[_c('SfGallery',{ref:"gallery",attrs:{"images":_vm.gallery}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }